<oes-breadcrumb></oes-breadcrumb>
<oes-organization-list
  *ngIf="organizations"
  [organizations]="organizations"
  [exportName]="'Investor List'"
  [profileType]="'investor'">
</oes-organization-list>
